export default __webpack_public_path__ + "static/media/icon-seta-dupla.c3ddfd56.svg";